import { lazy, useMemo, forwardRef, Suspense } from "react";
import { withConfiguration } from "lcm-iot-commons";

type Props = {
  configuration: {
    captchaImplementation?: "google" | "alibaba";
  };
};

export const Captcha = forwardRef<$TSFixMe, Props>((props, ref) => {
  const { configuration } = props;

  const CaptchaImplementation = useMemo(
    () =>
      lazy(() =>
        configuration.captchaImplementation === "alibaba"
          ? /* istanbul ignore next */
            import("./AliCaptcha")
          : import("./GoogleCaptcha"),
      ),
    [],
  );

  return (
    <Suspense fallback={<div>Loading...</div>}>
      {/* @ts-expect-error TS(2322) FIXME: Type '{ forwardedRef: ForwardedRef<any>; configura... Remove this comment to see the full error message */}
      <CaptchaImplementation {...props} forwardedRef={ref} />
    </Suspense>
  );
});

Captcha.displayName = "Captcha";

export default withConfiguration(Captcha);
